export const IS_E2E = process.env.NEXT_PUBLIC_IS_E2E;

export const FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL || 'http://localhost:4200';

export const PRIVATE_API_URL = process.env.NEXT_PUBLIC_SECURE_API_URL || 'http://localhost:8083';
export const PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:4001';

export const GRAPHQL_PATH = process.env.NEXT_PUBLIC_GRAPHQL_PATH || '/graphql';
export const PUBLIC_GRAPHQL_URL = PUBLIC_API_URL + GRAPHQL_PATH;
export const PRIVATE_GRAPHQL_URL = PRIVATE_API_URL + GRAPHQL_PATH;

export const TYPESENSE_API_URL =
  process.env.NEXT_PUBLIC_TYPESENSE_API_URL ?? 'http://localhost:8108';
export const TYPESENSE_API_KEY =
  process.env.NEXT_PUBLIC_TYPESENSE_API_KEY ?? 'EkkgcMDToMo1JAkiSiR5r0mhmSdDRwNf';

export const AUTH_DOMAIN = process.env.NEXT_PUBLIC_AUTH_DOMAIN;
export const AUTH_CLIENT_ID = process.env.NEXT_PUBLIC_AUTH_CLIENT_ID;

export const AUTH_AUDIENCE = process.env.NEXT_PUBLIC_AUTH_AUDIENCE || 'talents-staging';
export const AUTH_SCOPE = process.env.NEXT_PUBLIC_AUTH_SCOPE || 'user offline_access';
export const ORIGINAL_DOMAIN =
  process.env.NEXT_PUBLIC_AUTH_ORIGINAL_DOMAIN || 'iglu-prod.eu.auth0.com';

export const IMPERSONATE_PERMISSION =
  process.env.NEXT_PUBLIC_IMPERSONATE_PERMISSION || 'super:impersonate';
export const ADMIN_PERMISSION = process.env.NEXT_PUBLIC_ADMIN_PERMISSION || 'super:admin';

export const MATOMO_JS_TRACKER_FILE = process.env.NEXT_PUBLIC_MATOMO_JS_TRACKER_FILE || '';
export const MATOMO_PHP_TRACKER_FILE = process.env.NEXT_PUBLIC_MATOMO_PHP_TRACKER_FILE || '';
export const MATOMO_SITE_ID = process.env.NEXT_PUBLIC_MATOMO_SITE_ID;
export const MATOMO_URL = process.env.NEXT_PUBLIC_MATOMO_URL;

export const LEADGEN_BACKEND_URL = process.env.NEXT_PUBLIC_LEADGEN_BACKEND_URL;
export const LEADGEN_FRONTEND_URL = process.env.NEXT_PUBLIC_LEADGEN_FRONTEND_URL;

export const REFRESH_TOKEN_ABSOLUTE_DAYS = Number(
  process.env.NEXT_PUBLIC_REFRESH_TOKEN_ABSOLUTE_DAYS ?? '30',
);

export const AUTH_COOKIE_DOMAIN = '.talentprofile.net';
